module.exports = __webpack_public_path__ + "img/your-tickets.5c6505b1.svg";